/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForJiraServiceDesk extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForJiraServiceDesk");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForJiraServiceDesk.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForJiraServiceDesk>): ServiceAccountNativeDetailsForJiraServiceDesk {
        let obj = Object.assign(new ServiceAccountNativeDetailsForJiraServiceDesk(), model);
        ServiceAccountNativeDetailsForJiraServiceDesk.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForJiraServiceDesk>): ServiceAccountNativeDetailsForJiraServiceDesk {
        if (!model) return null;
        return ServiceAccountNativeDetailsForJiraServiceDesk.newInstance(<ServiceAccountNativeDetailsForJiraServiceDesk> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForJiraServiceDesk) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForJiraServiceDesk.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForJiraServiceDesk): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForJiraServiceDesk.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
